export enum LimitKeys {
  CreateGoal = 'createGoal',
  CreateHabit = 'createHabit',
  HabitIcons = 'habitIcons',
  HabitScheduleTarget = 'habitScheduleTarget',
  CreateSmartList = 'createSmartList',
  GoalUserPhoto = 'goalUserPhoto',
  BiometricAppLock = 'biometricAppLock',
  CustomizeDefaultLifeAreas = 'customizeDefaultLifeAreas',
  CustomLifeAreas = 'customLifeAreas',
  SubGoals = 'subGoals',
  VisionUserPhoto = 'visionUserPhoto',
  Insights = 'insights',
  MobileCalendar1DayView = 'mobileCalendar1DayView',
  MobileCalendar2DayView = 'mobileCalendar2DayView',
  MobileCalendar3DayView = 'mobileCalendar3DayView',
  MobileCalendarWeekView = 'mobileCalendarWeekView',
  DesktopCalendarDay = 'desktopCalendarDay',
  DesktopCalendarFourDays = 'desktopCalendarFourDays',
  DesktopCalendarWeek = 'desktopCalendarWeek',
  DesktopCalendarMonth = 'desktopCalendarMonth',
  DesktopGoalsOverviewTimeline = 'desktopGoalsOverviewTimeline',
}

export const limitKeys = Object.values(LimitKeys);
